import { action } from 'satcheljs';
import Folder from 'owa-service/lib/contract/Folder';
import { FavoritePersonaData, FavoritePrivateDistributionListData } from 'owa-favorites-types';

/**
 * Favorites have been loaded in store
 */
export default action(
    'PERSONA_SEARCH_FOLDERS_LOADED',
    (
        existingFolders: Folder[],
        personaOrPdlFavorites: (FavoritePersonaData | FavoritePrivateDistributionListData)[]
    ) => {
        return {
            existingFolders,
            personaOrPdlFavorites,
        };
    }
);
